<template>
    <div id="timeline">
        <div id="timeline-center">
            <div id="chapters">
                <div class="chapter" style="width: 3.75%">
                    <span @mouseenter="hoverTimeSound()" @click="goChapter(0)" data-time="00:00"></span>
                </div>

                <div class="chapter" style="width: 15%">
                <span data-time="00:21" @mouseenter="hoverTimeSound()" @click="goChapter(21)">

                </span>
                </div>


                <div class="chapter" style="width: 51%">
                    <span data-time="01:45" @mouseenter="hoverTimeSound()" @click="goChapter(100)"></span>
                </div>

                <div class="chapter" style="width: 10%">
                    <span data-time="06:31" @mouseenter="hoverTimeSound()" @click="goChapter(391)"></span>
                </div>

                <div class="chapter" style="width: 20%">
                    <span data-time="07:28" @mouseenter="hoverTimeSound()" @click="goChapter(448)"></span>
                </div>

                <div class="chapter">
                    <span data-time="09:20" @mouseenter="hoverTimeSound()" @click="goChapter(549)"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import hover from '@/assets/audio/cursor_move.wav';

    export default {
        name: 'Timeline',
        methods: {
            goChapter(time) {
                let video = this.$parent.video;
                video.currentTime = time
                video.play()
                this.$parent.$refs.audioFile.play()
            },
            hoverTimeSound() {
                let sound = new Audio(hover)
                // sound.play()
            }
        }
    }
</script>

<style scoped lang="scss">
    #timeline {
        position: fixed;
        bottom: 0;
        z-index: 3;
        left: 0;
        width: 100%;
        opacity: 0.2;
        transition: 0.2s;
        padding: 10px 0;
        &:hover {
            padding: 20px 0;
            opacity: 1;
        }
        #timeline-center {
            display: flex;
            justify-content: center;

            #chapters {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                width: 80%;
                &:after {
                    position: absolute;
                    top: 9px;
                    left: 0;
                    width: 100%;
                    content: '';
                    height: 2px;
                    background-color: #b71540;
                }
                .chapter {
                    position: relative;
                    height: 20px;
                    z-index: 1;
                    span {
                        background-color: #b71540;
                        padding: 10px;
                        border-radius: 100%;
                        display: inline-block;
                        cursor: pointer;
                        position: relative;
                        transition: 0.2s;
                        &:after {
                            content: attr(data-time);
                            position: absolute;
                            top: -40px;
                            display: none;
                            transition: 0.2s;
                            left: -17px;
                            text-align: center;
                            color: white;
                            font-weight: bold;
                            font-size: 1.3rem;
                            text-shadow: 1px 3px 3px #353535;
                        }
                        &:hover {
                            background-color: #eb2f06;
                            &:after {
                                display: initial;
                            }
                        }
                    }

                }
            }
        }
    }
</style>